(function () {
    SUGApp.service('enterpriseService', enterpriseService);

    enterpriseService.$inject = ['$injector','SUGUtilities', '$window'];
    function enterpriseService($injector, SUGUtilities, $window) {

        var loginfactory;
        if ($injector.has('loginfactory')) {
            loginfactory = $injector.get('loginfactory');
        }

        // define service
        var service = {
            xhrLoginHandler: function (Method, url, data, goAction, timeout) {
                return SUGUtilities.APISyncCall(Method, url, data, goAction, timeout).then(
                    function(response){
                        var r = SUGUtilities.lowerCaseKeys(response.data);
                        if (SUGUtilities.ajaxResultInvalid(response)) {
                            // check for logged out user
                            if (r.code && r.code == 1002 && loginfactory) {
                                // not logged in
                                service.myLoginInstance = service.myLoginInstance || loginfactory.getLogin(true);
                                return service.myLoginInstance.login(true).then(
                                    function () {
                                        // login succeeded, try to call self again
                                        return service.xhrLoginHandler(Method, url, data, goAction, timeout);
                                    }, function () {
                                        // login failed, just refresh the page and force a login
                                        $window.location.reload();
                                        return {};
                                    }
                                );
                            } else if (r.code && r.code === 1003) {
                                // invalid permission - direct to no access page
                                $window.location.href = '/index.cfm?go=c.NoAccess';
                                return {};
                            } else {
                                // standard error handling, not login/security related error
                                return response;
                            }
                        } else {
                            return response;
                        }
                    }
                );

            },

            /**
             * Method to display an error modal when an Ajax error occurs
             **/
            errorHandler: function (errorObj) {
                var errMessage = SUGUtilities.resultErrorHandler(errorObj);
                if (errMessage.indexOf('Make sure you are logged in and have an active session.') >= 0) {
                    $window.location.reload();
                    return;
                }
                // no longer logged in
                if (errorObj.CODE && errorObj.CODE === 1002) {
                    $window.location.reload();
                    return;
                } else {
                    SUGUtilities.showMagnificAlert(errMessage, 'error', '', 'Sorry!');
                }
            },

            enterpriseSubmit: function (data) {
                return service.xhrLoginHandler('post', '', data, 'c.enterpriseSubmit', 30000);
            }
        };

        return service;
    }
}());
